export class Image {
    defaults() {
        return {
            link: '',
            source: null,
        }
    }
}

